const body = document.body;
const navigation = {
  className: {
    menuOpen: 'menu--open',
    menuClose: 'menu--closing',
    header: 'header--menuOpen',
  },
  currentImage: null,

  setImage(item) {
    const selector = item.dataset.selector;
    const image = document.querySelector(selector);

    navigation.showImage(image);
  },

  showImage(image) {
    if (!image) return;

    if (navigation.currentImage && navigation.currentImage !== image) {
      navigation.currentImage.classList.remove('is-active');
    }

    image.classList.add('is-active');
    navigation.currentImage = image;
  },

  resetImage() {
    if (!navigation.defaultImage) return;

    navigation.showImage(navigation.defaultImage);
  },

  getHiddenElementHeight(element) {
    // Clonar el elemento
    const clone = element.cloneNode(true);

    // Aplicar estilos temporales para medir la altura real
    clone.style.height = 'auto';
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.overflow = 'visible';
    clone.style.maxHeight = 'none';

    // Insertarlo en el DOM para poder medirlo
    document.body.appendChild(clone);
    const height = clone.getBoundingClientRect().height;
    document.body.removeChild(clone);

    return height;
  },

  setSubmenuHeight() {
    navigation.dropdowns.forEach((dropdown) => {
      const submenu = dropdown.nextElementSibling;
      const height = navigation.getHiddenElementHeight(submenu);
      submenu.style.setProperty('--submenu-height', `${height}px`);
    });
  },

  toggleLinkActive(selected) {
    navigation.items.forEach((item) => {
      if (item === selected) {
        item.classList.add('is-active');
      } else {
        item.classList.add('is-disabled');
      }
    });
  },

  removeLinkActive() {
    navigation.items.forEach((item) => {
      item.classList.remove('is-active', 'is-disabled');
    });
  },

  mouseEnter(event) {
    const item = event.target;
    const link = item.firstElementChild;

    navigation.toggleLinkActive(item);
    navigation.setImage(link);
  },

  mouseLeave() {
    navigation.removeLinkActive();
    navigation.resetImage();
  },

  dropdownToggle(event) {
    event.preventDefault();
    const submenu = this.nextElementSibling;

    if (submenu.classList.contains('is-active')) {
      submenu.classList.remove('is-active');
    } else {
      submenu.classList.add('is-active');
    }
  },

  closeMenu() {
    navigation.menu.classList.add(navigation.className.menuClose);
    navigation.menu.classList.remove(navigation.className.menuOpen);

    const handleCloseTransition = (event) => {
      if (event.target !== navigation.menu) return;
      if (event.propertyName !== 'height') return;

      body.classList.remove('hidden', 'menu-open');
      navigation.header.classList.remove(navigation.className.header, 'is-active');
      navigation.menu.classList.remove(navigation.className.menuClose);

      navigation.menu.removeEventListener('transitionend', handleCloseTransition);
    };

    navigation.menu.addEventListener('transitionend', handleCloseTransition);
  },

  openMenu() {
    navigation.header.classList.add(navigation.className.header, 'is-active');
    navigation.menu.addEventListener('transitionend', () => {
      body.classList.add('hidden', 'menu-open');
    }, { once: true });
    navigation.menu.classList.add(navigation.className.menuOpen);
  },

  menuToggle(event) {
    event.preventDefault();

    if (navigation.header.classList.contains(navigation.className.header)) {
      return navigation.closeMenu();
    }

    return navigation.openMenu();
  },

  init() {
    navigation.menu = document.querySelector('.js-menu');
    navigation.items = navigation.menu.querySelectorAll('.js-menu-items');
    navigation.defaultImage = navigation.menu.querySelector('.menu__image--default');
    navigation.currentImage = navigation.defaultImage;
    navigation.header = document.querySelector('.js-header');
    navigation.hamburguer = navigation.header.querySelector('.js-toggle-menu-dropdown');
    navigation.dropdowns = navigation.menu.querySelectorAll('.js-menu-dropdown');

    if (navigation.items.length) {
      navigation.items.forEach((item) => {
        item.addEventListener('mouseenter', navigation.mouseEnter);
        item.addEventListener('mouseleave', navigation.mouseLeave);
      });
    }

    if (navigation.dropdowns.length) {
      navigation.setSubmenuHeight();
      navigation.dropdowns.forEach((dropdown) => {
        dropdown.addEventListener('click', navigation.dropdownToggle);
      });

      window.addEventListener('resize', navigation.setSubmenuHeight);
    }

    if (navigation.hamburguer) {
      navigation.hamburguer.addEventListener('click', navigation.menuToggle);
    }
  },
};

export default function setNavigation() {
  if (!document.querySelector('.js-menu')) return;

  navigation.init();
}
